export const getValueFromObjectKeyString = (obj: any, keyString: string) => {
	let value = obj as any;
	keyString.split('.').forEach(key => {
		value = value[key];
	});
	return value;
};
